import React from 'react'

const SearchErrorHandler = ({text}) => {
    return (
        <>
            <div className="xpress_no_trans text-center pt-4" >
                <img
                    src={process.env.PUBLIC_URL + '/assets/images/searchcloud.jpg'}
                    alt=""
                    title=""
                />
                <div className="mb-5 mt-3">
                    <label>{text}</label>
                </div>
            </div>
        </>
    )
}

export default SearchErrorHandler